import BackToTopButton from "components/PageContent/lib/PageBackToTopButton";
import {
	PageContentContainer,
	PageContentInner
} from "components/PageContent/styled";
import { images } from "helpers";
import { useImagePath } from "hooks/useImagePath";
import { createRef, useEffect, useState } from "react";
import PageHero from "./lib/Hero";
import Section from "./lib/Section";
import { useSections } from "./sections";
import { SectionContent, landingPageContainerSxProps } from "./styled";
import { useWebStoreContext } from "contexts";
import { SignUpIncentiveResponse } from "interfaces/sign-up-incentive";
import { FeatureType } from "interfaces/feature-tracker";
import { featureTrackerAPI } from "redux/apis";
import { useLinks } from "hooks/useLinks";
import { PWABanner } from "components/PWA/PWABanner";
import { isMobile } from "react-device-detect";

export interface ILandingPageSection {
	image: string;
	title: string;
	content: string;
	linkHref: string;
	analytics: string;
	playgamiAnalytics?: string;
	linkText: string;
	linkIsExternal: boolean;
	featureFlag?: string;
	openExternalSameTab?: boolean;
	isEnabled: boolean;
}

const LandingPage = () => {
	const [contentSections] = useState<ILandingPageSection[]>(
		useSections().filter((section) => section.isEnabled)
	);
	const links = useLinks();
	const sectionContentRef = createRef<HTMLDivElement>();
	const { authToken } = useWebStoreContext();
	const { data }: { data?: SignUpIncentiveResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.SIGN_UP_INCENTIVE,
			token: authToken?.value
		});

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const { getImage } = useImagePath("local");

	const pageHeaderBackground =
		images.spec_landing_page__page_header_background__template.src;
	const pageContentBackground =
		images.spec_landing_page__page_content_background.src;

	return (
		<PageContentContainer
			className="page-container animate__animated animate__fadeIn"
			sx={{
				...landingPageContainerSxProps,
				backgroundImage: {
					xs: `url(${getImage(pageHeaderBackground, "small")}), url(${getImage(
						pageContentBackground
					)})`,
					sm: `url(${getImage(pageHeaderBackground, "large")}), url(${getImage(
						pageContentBackground
					)})`
				}
			}}
		>
			<PageContentInner
				className="page-content"
				sx={{ maxWidth: { lg: "80%" } }}
			>
				<PageHero sectionContentRef={sectionContentRef} />
				<SectionContent className="section-content" ref={sectionContentRef}>
					{isMobile && <PWABanner from="landing-page" />}
					{contentSections.map((section, index): JSX.Element => {
						const isReversed = index % 2 === 0;

						if (
							section.title === links.sign_up_scopely.title &&
							(!authToken ||
								!data?.tracker?.incentiveRewardId ||
								data?.tracker?.scopelyUserId)
						) {
							return <div key={section.title}></div>;
						}
						return (
							<Section
								key={section.title}
								section={{ ...section, image: getImage(section.image) }}
								isReversed={isReversed}
							/>
						);
					})}
				</SectionContent>
				<BackToTopButton source="landing_page" />
			</PageContentInner>
		</PageContentContainer>
	);
};

export default LandingPage;
